import { LeafErrorMessage } from "../../../../../../common/leaf/LeafErrorMessage/LeafErrorMessage";
import ProfileLoader from "../../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import { getLoginAffAbo } from "../../../../../../reducers/model/boot";
import { useGetCustomerListQuery } from "../../../../../../services/Customer/CustomerList/customerListAPI";
import { useGetProfileQuery } from "../../../../../../services/Profile/profileAPI";
import { useAppSelector } from "../../../../../../store";
import { profileProfileTabErrorTrack } from "../../../../../../common/tealium/CustomerProfile/Profile/ProfileTabViewsTrack/ProfileTabTrack";
import CustomerAdditionalInfo from "./CustomerAdditionalInfo/CustomerAdditionalInfo";
import { ErrorTile } from "../../../../../../common/components/ErrorTile/ErrorTile";

const ProfileTab = () => {
  const profileABO = useAppSelector((state) => state.profile.affAbo);
  const customerIds = profileABO.split("-")[1]; // extract customer number only

  const { selectedPeriod } = useAppSelector(({ period }) => period);

  const boot = useAppSelector(({ boot }) => boot);
  const affAbo = getLoginAffAbo({ boot });

  const {
    isFetching: isFetchingProfile,
    isError: isErrorProfile,
    data: profile,
    refetch: refetchProfile,
  } = useGetProfileQuery({
    period: selectedPeriod,
    affAbo: profileABO,
  });

  const {
    isFetching: isFetchingCustomer,
    isError: isErrorCustomer,
    data: customerData,
    refetch: refetchCustomerList,
  } = useGetCustomerListQuery({
    period: selectedPeriod,
    affAbo,
    pageNum: 1,
    pageSize: 1,
    sortValue: "LAST_ORDER_DATE",
    sortOrder: "ASC",
    customerIds,
  });

  const isFetching = isFetchingProfile || isFetchingCustomer;
  const isFetched = isFetchingProfile === false && isFetchingCustomer === false;
  const isError = isErrorProfile || isErrorCustomer;

  const handleRefetch = () => {
    refetchProfile();
    refetchCustomerList();
  };

  if (isError === true) {
    profileProfileTabErrorTrack();
  }

  if (isFetched === true && profile?.aboInfo && customerData) {
    const { privacyFlag, isoLanguageCode, isoBirthdate, entryDate, renewalDate } = profile.aboInfo;
    const { LastOrderDate, LastReturnDate } = customerData.CustomerList?.[0] || [];

    return (
      <>
        <CustomerAdditionalInfo
          privacyFlag={privacyFlag}
          recentOrderDate={LastOrderDate}
          recentReturnDate={LastReturnDate}
          isoLanguageCode={isoLanguageCode}
          isoBirthdate={isoBirthdate}
          entryDate={entryDate}
          renewalDate={renewalDate}
        />
      </>
    );
  }

  return (
    <>
      <ErrorTile
        clickFunction={handleRefetch}
        errorStatus={isError}
        isLoading={isFetching}
        tealiumTrackId="profile-tab"
      />
      <ProfileLoader row={6} card={true} isFetching={isFetching} />
    </>
  );
};

export default ProfileTab;
